import React from "react";
import Grid from "@mui/material/Grid";
import { TextField, SimpleShowLayout } from "react-admin";
import {
  raLabeledStyle,
  raSimpleShowLayoutFlexRow,
  raSimpleShowLayoutCellFlex,
} from "../../../../customStyles/ra-custom-styles";

export const PublishersExpand = () => {
  return (
    <Grid
      container
      spacing={3}
    >
      <Grid
        item
        xs={12}
        md={4}
        lg={4}
      >
        <SimpleShowLayout
          sx={{
            "& .RaSimpleShowLayout-row": raSimpleShowLayoutFlexRow,
            "& .RaLabeled-label": raLabeledStyle,
          }}
        >
          <TextField
            label="Аб.камп."
            source="campaign_name"
          />
          <TextField
            label="Фирма"
            source="company"
          />
          <TextField
            label="Начало на абонамента"
            source="subscription_purchase_date"
          />
          <TextField
            label="Сума"
            source="price_euro"
          />
        </SimpleShowLayout>
      </Grid>
      <Grid
        item
        xs={12}
        md={4}
        lg={4}
      >
        <SimpleShowLayout
          sx={{
            "& .RaSimpleShowLayout-row": raSimpleShowLayoutFlexRow,
            "& .RaLabeled-label": raLabeledStyle,
          }}
        >
          <TextField
            label="ПК"
            source="postcode"
          />
          <TextField
            label="Област"
            source="district"
          />
          <TextField
            label="Община"
            source="municipality"
          />
          <TextField
            label="Адрес"
            source="address"
          />
        </SimpleShowLayout>
      </Grid>
      <Grid
        item
        xs={12}
        md={4}
        lg={4}
      >
        <SimpleShowLayout
          sx={{
            "& .RaSimpleShowLayout-row": raSimpleShowLayoutFlexRow,
            "& .RaLabeled-label": raLabeledStyle,
          }}
        >
          <TextField
            label="Квартал"
            source="neighborhood"
          />
          <TextField
            label="Улица"
            source="street"
          />
          <TextField
            label="Улица номер"
            source="street_number"
          />
        </SimpleShowLayout>
        <SimpleShowLayout
          sx={{
            "& .RaSimpleShowLayout-row": raSimpleShowLayoutCellFlex,
            "& .RaLabeled-label": raLabeledStyle,
            "& .RaSimpleShowLayout-stack": raSimpleShowLayoutFlexRow,
          }}
        >
          <TextField
            label="Бл."
            source="building"
          />
          <TextField
            label="Вх."
            source="entrance"
          />
          <TextField
            label="Ет."
            source="floor"
          />
          <TextField
            label="Ап."
            source="apartment"
          />
        </SimpleShowLayout>
      </Grid>
    </Grid>
  );
};
